import React, { useEffect, useState } from 'react'
import EditProfileHeader from './EditProfileHeader'
import EditPersonalInfo from './EditPersonalInfo'
import EditEducation from './EditEducation'
import EditSkills from './EditSkills'
import EditWorkExp from './EditWorkExp'
import axios from 'axios'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router'
import { useAlert } from '../../../constants/AlertProvider'
import { CheckCircleIcon, ArrowLeftIcon } from '@heroicons/react/24/solid'

export default function EditProfile() {
    const [applicationId, setApplicationId] = useState("");
    const [saveStatus, setSaveStatus] = useState(null);
    const [address, setAddress] = useState("");
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleSave = async () => {
        setSaveStatus('saving');
        try {
            const userId = Cookies.get("id");
            await axios.patch(
                `/api/users/${userId}/`,
                { address },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRFToken': Cookies.get('csrftoken'),
                    },
                    withCredentials: true,
                }
            );
            setSaveStatus('saved');
            showAlert("Profile saved!", "success");
            setTimeout(() => setSaveStatus(null), 3000);
        } catch (e) {
            setSaveStatus(null);
            showAlert("Failed to save profile", "error");
        }
    };
    const showAlert = useAlert();

    useEffect(() => {
        const fetchApplicationId = async () => {
            const userId = Cookies.get("id");
            try {
                const userRes = await axios.get(`/api/users/${userId}/`, { withCredentials: true });
                const appIds = userRes.data.applicationids;
                if (appIds && appIds.length > 0) {
                    setApplicationId(appIds[0].id);
                }
            } catch (error) {
                showAlert("Failed to fetch data", "error");
                console.log(error);
            }
        }
        fetchApplicationId();
    }, []);

    return (
        <div className="max-w-4xl mx-auto px-4 py-8 gap-y-4">
            <div className={`border-b border-b-gray-300 dark:border-b-gray-700 fixed top-0 left-0 right-0 z-50 flex justify-between items-center h-16 px-4 sm:px-6 lg:px-8 transition-all duration-300 ${isScrolled
                ? "bg-gray-300/20 dark:bg-gray-800/60 backdrop-blur-md shadow-lg w-11/12 mx-auto rounded-b-xl"
                : "bg-white dark:bg-gray-900 w-full"
                }`}>
                <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Edit Profile</h1>
                <div className='flex flex-row gap-x-2'>
                    <button
                        onClick={handleSave}
                        disabled={saveStatus === 'saving'}
                        className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-full transition-colors disabled:bg-blue-400"
                    >
                        {saveStatus === 'saving' ? (
                            'Saving...'
                        ) : saveStatus === 'saved' ? (
                            <>
                                <CheckCircleIcon className="w-5 h-5" />
                                Saved
                            </>
                        ) : (
                            'Save Changes'
                        )}
                    </button>

                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 px-4 py-2 rounded-full transition-colors"
                    >
                        <ArrowLeftIcon className="w-5 h-5" />
                        Go back
                    </button>
                </div>
            </div>
            <div className="space-y-6">
                <EditProfileHeader />
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                    <div className="px-6 py-4 bg-gray-50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
                        <h2 className="text-lg font-medium text-gray-800 dark:text-gray-100">
                            Personal Information
                        </h2>
                    </div>
                    <div className="p-6">
                        <EditPersonalInfo address={address} setAddress={setAddress} />
                    </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                    <div className="px-6 py-4 bg-gray-50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
                        <h2 className="text-lg font-medium text-gray-800 dark:text-gray-100">Education</h2>
                    </div>
                    <div className="p-6">
                        <EditEducation applicationId={applicationId} />
                    </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                    <div className="px-6 py-4 bg-gray-50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
                        <h2 className="text-lg font-medium text-gray-800 dark:text-gray-100">Skills</h2>
                    </div>
                    <div className="p-6">
                        <EditSkills applicationId={applicationId} />
                    </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                    <div className="px-6 py-4 bg-gray-50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
                        <h2 className="text-lg font-medium text-gray-800 dark:text-gray-100">
                            Work Experience
                        </h2>
                    </div>
                    <div className="p-6">
                        <EditWorkExp applicationId={applicationId} />
                    </div>
                </div>
            </div>
        </div>
    )
}
